class RecipeCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.recipe-carousel__track');
    this.slides = [...this.querySelectorAll('.recipe-carousel__slide')];
    this.dots = [...this.querySelectorAll('.slider-counter__link')];
    this.prevBtn = this.querySelector('.recipe-carousel__btn--prev');
    this.nextBtn = this.querySelector('.recipe-carousel__btn--next');
    this.announcer = this.querySelector('.recipe-carousel__announcer');
    this.currentIndex = 0;
    this.isAnimating = false;
    this.touchStartX = 0;
    this.touchStartY = 0;

    if (this.slides.length < 2) return;

    this.prevBtn?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.nextBtn?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

    // Clicking a non-active card navigates to it
    this.slides.forEach((slide, i) => {
      slide.addEventListener('click', () => {
        if (!slide.classList.contains('is-active')) this.goTo(i);
      });
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.currentIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.currentIndex + 1); }
    });

    this.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].clientX;
      this.touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });

    this.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - this.touchStartX;
      const dy = e.changedTouches[0].clientY - this.touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
        this.goTo(dx < 0 ? this.currentIndex + 1 : this.currentIndex - 1);
      }
    }, { passive: true });

    // Re-apply positions in case Liquid initial state differs (edge cases)
    this.updateSlidePositions();
  }

  goTo(index) {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const total = this.slides.length;
    const newIndex = ((index % total) + total) % total;

    const prev = this.slides[this.currentIndex];
    prev.classList.remove('is-active');
    prev.setAttribute('aria-hidden', 'true');
    prev.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
    this.dots[this.currentIndex]?.classList.remove('slider-counter__link--active');
    this.dots[this.currentIndex]?.removeAttribute('aria-current');

    this.currentIndex = newIndex;

    const curr = this.slides[this.currentIndex];
    curr.classList.add('is-active');
    curr.setAttribute('aria-hidden', 'false');
    curr.querySelectorAll('a, button').forEach((el) => el.removeAttribute('tabindex'));
    this.dots[this.currentIndex]?.classList.add('slider-counter__link--active');
    this.dots[this.currentIndex]?.setAttribute('aria-current', 'true');

    this.updateSlidePositions();

    if (this.announcer) {
      this.announcer.textContent = '';
      requestAnimationFrame(() => {
        this.announcer.textContent = `Slide ${this.currentIndex + 1} of ${total}`;
      });
    }

    setTimeout(() => { this.isAnimating = false; }, 800);
  }

  updateSlidePositions() {
    const total = this.slides.length;
    const allPos = ['pos--center', 'pos--right-1', 'pos--right-2', 'pos--left-1', 'pos--left-2', 'pos--hidden'];

    this.slides.forEach((slide, i) => {
      const offset = (i - this.currentIndex + total) % total;
      slide.classList.remove(...allPos);

      // Check total-1/-2 before 1/2 so small totals stay symmetric
      if (offset === 0) {
        slide.classList.add('pos--center');
      } else if (offset === 1) {
        slide.classList.add('pos--right-1');
      } else if (offset === total - 1) {
        slide.classList.add('pos--left-1');
      } else if (offset === 2) {
        slide.classList.add('pos--right-2');
      } else if (offset === total - 2) {
        slide.classList.add('pos--left-2');
      } else {
        slide.classList.add('pos--hidden');
      }
    });
  }
}

customElements.define('recipe-carousel', RecipeCarousel);
